import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './achivements.reducer';

export const AchivementsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const achivementsEntity = useAppSelector(state => state.achivements.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="achivementsDetailsHeading">
          <Translate contentKey="fivePlusApp.achivements.detail.title">Achivements</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{achivementsEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="fivePlusApp.achivements.name">Name</Translate>
            </span>
          </dt>
          <dd>{achivementsEntity.name}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="fivePlusApp.achivements.description">Description</Translate>
            </span>
          </dt>
          <dd>{achivementsEntity.description}</dd>
          <dt>
            <span id="feature">
              <Translate contentKey="fivePlusApp.achivements.feature">Feature</Translate>
            </span>
          </dt>
          <dd>{achivementsEntity.feature ? 'true' : 'false'}</dd>
          <dt>
            <span id="requiredProof">
              <Translate contentKey="fivePlusApp.achivements.requiredProof">Required Proof</Translate>
            </span>
          </dt>
          <dd>{achivementsEntity.requiredProof ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="fivePlusApp.achivements.pointAllocationSystem">Point Allocation System</Translate>
          </dt>
          <dd>{achivementsEntity.pointAllocationSystem ? achivementsEntity.pointAllocationSystem.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/achivements" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/achivements/${achivementsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default AchivementsDetail;
